import { render } from "./CopyLinkDialog.vue?vue&type=template&id=5bcbf0a2&scoped=true&ts=true"
import script from "./CopyLinkDialog.vue?vue&type=script&lang=ts"
export * from "./CopyLinkDialog.vue?vue&type=script&lang=ts"

import "./CopyLinkDialog.vue?vue&type=style&index=0&id=5bcbf0a2&scoped=true&lang=scss"

import exportComponent from "/Users/gerald/Projects/designium/RandselSimulation/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bcbf0a2"]])

export default __exports__